
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
const baseUrl = '2022GKDBM';
@Component
export default class ViewHolder extends Vue {
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '招考大帮忙',
      url: location.href,
      subtitle: `招考大帮忙`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '招考大帮忙',
        subtitle: `招考大帮忙`,
        image: cover,
      });
    }
  }

  // async created() {
  //   // const index = this.tabs.findIndex((item: any) => {
  //   //   return item.path === this.$route.path;
  //   // });
  //   // this.activeTab = index > -1 ? index : 0;
  //   const ret = await getBaseInfo();
  //   this.baseInfo = ret.data;
  //   // 添加pv统计
  //   if (this.baseInfo.activityId) {
  //     this.$addPv(this.baseInfo.activityId);
  //   }
  // }
}
